export default __webpack_public_path__ + "static/media/hp.e79b951a.png";